var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcess2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.546,40.485c0-3.826-3.112-6.938-6.938-6.938s-6.938,3.112-6.938,6.938s3.112,6.938,6.938,6.938 S32.546,44.311,32.546,40.485z M25.608,43.423c-1.62,0-2.938-1.318-2.938-2.938s1.318-2.938,2.938-2.938s2.938,1.318,2.938,2.938 S27.228,43.423,25.608,43.423z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,47.423c3.826,0,6.938-3.112,6.938-6.938S51.826,33.547,48,33.547c-3.826,0-6.938,3.112-6.938,6.938 S44.174,47.423,48,47.423z M48,37.547c1.62,0,2.938,1.318,2.938,2.938S49.62,43.423,48,43.423s-2.938-1.318-2.938-2.938 S46.38,37.547,48,37.547z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.393,33.547c-3.826,0-6.938,3.112-6.938,6.938s3.112,6.938,6.938,6.938c3.825,0,6.938-3.112,6.938-6.938 S74.218,33.547,70.393,33.547z M70.393,43.423c-1.62,0-2.938-1.318-2.938-2.938s1.318-2.938,2.938-2.938s2.938,1.318,2.938,2.938 S72.013,43.423,70.393,43.423z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.72,42.485h2.168c1.104,0,2-0.896,2-2s-0.896-2-2-2H35.72c-1.104,0-2,0.896-2,2S34.615,42.485,35.72,42.485z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.112,42.485h2.168c1.104,0,2-0.896,2-2s-0.896-2-2-2h-2.168c-1.104,0-2,0.896-2,2S57.008,42.485,58.112,42.485z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.804,53.278c-3.826,0-6.938,3.112-6.938,6.938c0,3.825,3.112,6.938,6.938,6.938s6.938-3.112,6.938-6.938 C43.742,56.391,40.629,53.278,36.804,53.278z M36.804,63.154c-1.62,0-2.938-1.317-2.938-2.938s1.318-2.938,2.938-2.938 s2.938,1.318,2.938,2.938S38.424,63.154,36.804,63.154z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.196,53.278c-3.826,0-6.938,3.112-6.938,6.938c0,3.825,3.112,6.938,6.938,6.938c3.825,0,6.938-3.112,6.938-6.938 C66.134,56.391,63.021,53.278,59.196,53.278z M59.196,63.154c-1.62,0-2.938-1.317-2.938-2.938s1.318-2.938,2.938-2.938 s2.938,1.318,2.938,2.938S60.816,63.154,59.196,63.154z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.084,58.217h-2.168c-1.104,0-2,0.896-2,2s0.896,2,2,2h2.168c1.104,0,2-0.896,2-2S50.188,58.217,49.084,58.217z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.142,53.289c0.339,0,0.684-0.086,0.998-0.269c0.957-0.552,1.284-1.775,0.731-2.731l-1.084-1.877 c-0.552-0.957-1.776-1.286-2.731-0.732c-0.957,0.552-1.284,1.776-0.731,2.732l1.084,1.877 C52.778,52.931,53.45,53.289,54.142,53.289z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess2);
export default __webpack_public_path__ + "static/media/process-2.1a89ae70ff00076b5d9b539710667af6.svg";
export { ForwardRef as ReactComponent };